module.exports = __webpack_public_path__ + "static/media/available.229440aa.svg";